export default class DeviceDetection {
    detection() {
        let device = {
            isMobile:false, 
            isTablet:false, 
            isDesktop:false
        };

        if (window.innerWidth > 1024) {
            device = { isMobile:false, isTablet:false, isDesktop:true };
        } else if (window.innerWidth < 993) {
            device = { isMobile:true, isTablet:false, isDesktop:false };
        } else {
            device = { isMobile:false, isTablet:true, isDesktop:false };
        }

        return device;
    }
}